module.exports = __webpack_public_path__ + "media/images/weather/217_night-d7d95d39c6b6250feeef1817c1e84d82.png";